import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from 'recharts';
import { DashboardChartBox, HeaderTitle } from '../styles';

interface PageTimingData {
  pageNo: number;
  averageTimeMs: number;
  totalResponses: number;
}

interface AverageTimeBarChartProps {
  pageTimingData: PageTimingData[];
  formatTime: (ms: number) => string;
}

const AverageTimeBarChart: React.FC<AverageTimeBarChartProps> = ({
  pageTimingData,
  formatTime,
}) => (
  <DashboardChartBox>
    <HeaderTitle>
      <p>Average Time Spent Per Page</p>
    </HeaderTitle>
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={pageTimingData}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 60,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="pageNo"
          label={{
            value: 'Page Number',
            position: 'insideBottom',
            offset: -10,
          }}
        />
        <YAxis
          label={{
            value: 'Time (seconds)',
            angle: -90,
            position: 'insideLeft',
          }}
          tickFormatter={value => `${Math.floor(value / 1000)}s`}
        />
        <Tooltip
          formatter={(value: any) => [`${formatTime(value)}`, 'Average Time']}
          labelFormatter={label => `Page ${label}`}
        />
        <Legend
          verticalAlign="bottom"
          align="center"
          height={36}
          wrapperStyle={{
            bottom: 0,
            paddingTop: 20,
            paddingBottom: 10,
          }}
        />
        <Bar name="Average Time" dataKey="averageTimeMs" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  </DashboardChartBox>
);

export default AverageTimeBarChart;
